<div class="badge-form" [formGroup]="formGroup">
  <pdq-checkbox formControlName="enabled" [label]="title" labelSize="small"></pdq-checkbox>

  @if (isEnabled) {
    <div class="badge-form__controls">
      <rich-text-editor
        label="Badge text"
        placeholder="e.g. Pay only {amount-left} more"
        [control]="textControl"
        [invalidMsg]="textControl.getError('body_text_missmatch')"
        [disabledFormats]="badgeDisabledFormats"
        [config]="{
          items: dynamicFieldsAutocompleteOptions$ | async,
          triggerChar: richTextConfig.triggerChar,
          filterByKey: richTextConfig.filterByKey,
          removeTriggerCharOnSelect: richTextConfig.removeTriggerCharOnSelect,
          descriptionKey: richTextConfig.descriptionKey,
          variant: richTextConfig.variant,
        }">
      </rich-text-editor>
      <p class="badge-form__hint">Type {{ '{' }} to insert product info.</p>

      <div class="flex-row flex-row--three">
        <pdq-input-color
          label="Background Color"
          [control]="backgroundColorControl"
          [formControl]="backgroundColorControl">
        </pdq-input-color>
        <pdq-input-color label="Text Color" [control]="textColorControl" [formControl]="textColorControl">
        </pdq-input-color>
        <pdq-dropdown formControlName="cornerRadius" title="Corner Radius" [options]="cornerRadiusOptions">
        </pdq-dropdown>
      </div>

      <div class="badge-form__icon-picker">
        <span class="badge-form__icon-label">Icon</span>
        <pdq-iconpicker
          [presetIconUrls]="presetIconKeys"
          [presetIconLabels]="presetIconLabels"
          [presetsAsIcons]="true"
          [supportsCustomUpload]="false"
          [iconUrl]="iconValue"
          (iconUrlChange)="onIconUrlChange($event)">
        </pdq-iconpicker>
      </div>
    </div>
  }
</div>
